import { SelectItem } from '../components/inputs/SelectInput';

export interface Site {
  snackbar: boolean;
  snackbarMsg: string;
  apiUrls?: APIUrl;
}

export interface APIUrl {
  core: string;
  home: string;
  integrations: string;
  user: string;
  notifications: string;
  site: string; 
}

export enum APIUrls {
  core,
  home,
  integrations,
  user
}

export interface Message {
  message: string;
  messageType: MessageTypes;
}

export enum MessageTypes {
  error = "error",
  notification = "notification",
  warning = "warning"
}

export const emptyMessage = {
  message: '',
  messageType: MessageTypes.notification
}

export interface Log {
  id: string;
  body: string;
  createdDate: number;
}

export enum CampaignStatus {
  new,
  complete,
  active,
  archived,
  deleted
}

export const emptyCampaign = {
  id: '', 
  name: '',
  type: '',
  client: '',
  collaboratorType: '',
  collaboratorId: '',
  status: '',
  templateId: '',
  redirectUrl: '',
  contactName: '',
  startDate: '',
  endDate: '',
  daysOfWeek: '',
  messagesPerDay: 0,
  createdDate: 0,
  totalContacts: 0,
  totalSent: 0,
  totalDoNotCall: 0,
  totalClicks: 0,
  totalActive: 0,
  totalOptOuts: 0,
  totalNonResponsive: 0,
  totalApplications: 0,
  totalLeads: 0,
  newMessage: false,
};

export interface Campaign {
  id: string; 
  name: string; 
  type: string; // refinance.....
  client: string;
  collaboratorType: string; // individual, team, branch
  collaboratorId: string; // id to get individual, team, branch
  status: string; // new, active, archived
  templateId: string;
  redirectUrl: string;
  contactName: string;
  startDate: string;
  endDate: string;
  daysOfWeek: string;
  messagesPerDay: number;
  createdDate: number;
  totalContacts: number;
  totalSent: number;
  totalDoNotCall: number;
  totalClicks: number;
  totalActive: number;
  totalOptOuts: number;
  totalNonResponsive: number;
  totalApplications: number;
  totalLeads: number;
  newMessage?: boolean;
}

export const emptyCampaignContact = {
  id: '',
  campaignId: '',
  fubId: 0,
  refId: '',
  firstName: '', 
  middleName: '', 
  lastName: '',
  phoneNumber: '',
  email: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  agent: '',
  lender: '',
  loanAmount: 0,
  loanType: '',
  homeValue: 0,
  status: '',
  newMessage: false,
  favoriteId: '',
  campaignName: '',
  disposition: '',
  createdDate: 0,
  updatedDate: 0
}

export interface CampaignContact {
  id: string; 
  campaignId: string;
  fubId: number;
  refId: string;
  firstName: string; 
  middleName: string; 
  lastName: string;
  phoneNumber: string;
  email: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  agent: string;
  lender: string;
  loanAmount: number;
  loanType: string;
  homeValue: number;
  status: string;
  newMessage?: boolean;
  favoriteId?: string;
  campaignName?: string;
  shortLink?: string;
  disposition?: string;
  updatedDate: number;
  createdDate: number;
}

export interface CampaignContactES {
  _index: string;
  _type: string;
  _id: string;
  _score: number;
  _source: CampaignContact;
}

export enum CampaignContactStatus {
  new,
  sent,
  active,
  clickThrough,
  optOut,
  nonResponsive,
  doNotCall,
  newMessage
}

export interface CampaignContactList {
  firstName: string; 
  lastName: string;
  phoneNumber: string;
  email: string;
}

export interface CampaignStats {
  total: number;
  totalNew: number;
  totalSent: number;
  totalActive: number;
  totalDoNotCalls: number;
  totalOptOuts: number;
  totalClickThroughs: number;
  totalNonResponsive: number;
  totalErrors: number;
  totalApplications: number;
}

export interface TabType{
  name: string;
  value: string;
}

export interface Collaborator {
  id?: string;
  campaignId?: string;
  userId: string;
  createdDate?: number;
  name?: string;
  type?: string;
  notify?: boolean;
}

export interface CampaignSession {
  campaign: Campaign;
  contacts: CampaignContact[][];
  contactErrors: CampaignContact[];
  collaborators: Collaborator[];
}

export const campaignStatusList: SelectItem[] = [
  {
    name: 'New',
    value: 'new'
  },
  {
    name: 'Started',
    value: 'started'
  },
  {
    name: 'Active',
    value: 'active'
  },
  {
    name: 'Archived',
    value: 'archived'
  },
  {
    name: 'Deleted',
    value: 'deleted'
  }
]

export const campaignStatusListRun: SelectItem[] = [
  {
    name: 'New',
    value: 'new'
  },
  {
    name: 'Started',
    value: 'started'
  },
  {
    name: 'Active',
    value: 'active'
  }
]

export const campaignContactStatusList: SelectItem[] = [
  {
    name: 'New',
    value: 'new'
  },
  {
    name: 'Sent',
    value: 'sent'
  },
  {
    name: 'Reply',
    value: 'active'
  },
  {
    name: 'Click Through',
    value: 'clickThrough'
  },
  {
    name: 'Application',
    value: 'application'
  },
  {
    name: 'Opt Out',
    value: 'optOut'
  },
  {
    name: 'Non Responsive',
    value: 'nonResponsive'
  },
  {
    name: 'Do Not Call',
    value: 'doNotCall'
  },
  {
    name: 'Error',
    value: 'error'
  }
];

export const campaignTypes: SelectItem[] = [
  {
    name: "Galilaio",
    value: "galilaio",
  },
  {
    name: "Refi",
    value: "refi",
  },
  {
    name: "Real estate",
    value: "realEstate",
  },
  {
    name: "Solar",
    value: "solar",
  },
  {
    name: "Restaurant",
    value: "restaurant",
  },
  {
    name: "Hair Salon",
    value: "hairSalon",
  },
  {
    name: "Coffee shop",
    value: "coffeeShop",
  },
  {
    name: "Debt",
    value: "debt",
  }
];

export const campaignClients: SelectItem[] = [
  {
    name: "Galilaio",
    value: "galilaio",
  },
  {
    name: "Homewize",
    value: "homewize",
  },
];

export const campaignContactStatusFilters: SelectItem[] = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Replies",
    value: "active",
  },
  {
    name: "Click Through",
    value: "clickThrough",
  },
  {
    name: "Sent",
    value: "sent",
  },
  {
    name: "Opt Out",
    value: "optOut",
  },{
    name: "Favorites",
    value: "favorites",
  },
];

export const campaignStatusFilters: SelectItem[] = [
  {
    name: "Active",
    value: "active",
  },
  {
    name: "New",
    value: "new",
  },
  {
    name: "Archived",
    value: "archived",
  }
];

export interface CampignContactFavorite {
  id: string;
  userId: string;
  campaignId: string;
  campaignName: string;
  contactId: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  contactPhone: string;
  newMessage?: boolean;
  updatedDate: number;
  createdDate: number;
}

export enum TeamType {
  team,
  branch,
  organization
}

export interface TeamList {
  teamId: string;
  teamName: string;
  teamType: string;
}

export interface Team {
  id: string;
  name: string;
  description: string;
  type: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  externalId: string;
  parentId: string;
  createdDate: number;
  teams: Team[];
  teamUsers: TeamUser[];
}

export const emptyTeam = {
  id: '',
  name: '',
  description: '',
  type: '',
  address: '',
  city: '',
  state: '',
  zipCode: '',
  externalId: '',
  parentId: '',
  createdDate: 0,
  teams: [],
  teamUsers: []
}

export enum TeamUserRole {
  manager,
  loanofficer,
  member
}

export interface TeamUser {
  id: string;
  teamId: string;
  userId: string;
  teamName: string;
  teamType: string;
  name: string;
  email: string;
  createdDate: number;
  parentId?: string;
  phone?: string;
  role?: string;
  canText?: boolean;
  meta?: string;
}

export const emptyTeamUser = {
  id: '',
  teamId: '',
  userId: '',
  parentId: '',
  teamName: '',
  teamType: '',
  name: '',
  email: '',
  phone: '',
  role: '',
  externalId: '',
  canText: true,
  meta: '',
  createdDate: 0
}

export interface TeamReportBody {
  replies: number;
  clicks: number;
  applications: number;
  optOuts: number;
}

export interface TeamReport {
  id: string;
  type: string;
  typeId: string;
  body: TeamReportBody;
  updatedDate: number;
  createdDate: number;
}

export interface Lead {
  id: string;
  type: string;
  refId: string;
  campaignId: string;
  campaignName: string;
  contactId: string;
  name: string;
  phoneNumber: string;
  email: string;
  shortLink: number;
  disposition: number;
  newMessage: number;
  updatedDate: number;
  createdDate: number;
}

export enum LeadTypes {
  pmiRemoval="pmiRemoval",
  welcomePackage="welcomePackage",
  solarSunScore="solarSunScore",
  dreamRate="dreamRate",
  contact="contact",
  incomplete="incomplete",
  campaign="campaign"
}

export const leadTypesList: SelectItem[] = [
  {
    name: 'PMI Removal',
    value: 'pmiRemoval'
  },
  {
    name: 'Welcome Package',
    value: 'welcomePackage'
  },
  {
    name: 'Solar Sun Score',
    value: 'solarSunScore'
  },
  {
    name: 'Dream Rate',
    value: 'dreamRate'
  },
  {
    name: 'Contact',
    value: 'contact'
  },
  {
    name: 'Incomplete',
    value: 'incomplete'
  }
]

export interface CampignContactNote {
  id: string;
  userId: string;
  userName: string;
  campaignId: string;
  campaignName: string;
  contactId: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  contactPhone: string;
  note: string;
  updatedDate: number;
  createdDate: number;
}



// WEBPACK FOOTER //
// ./src/entities/site.ts